/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_LEAST_COMPLETED_ACTIONS = gql`
  query GetLeastCompletedActions($filters: ActionGeneratorsInput!) {
    leastCompletedActions(filters: $filters) {
      id
      title
      description
      completionPercentage
      totalActions
      completedActions
      dueDateTime
    }
  }
`
